import { render, staticRenderFns } from "./QuillEditorCustomToolbar.vue?vue&type=template&id=1039ee6e&"
import script from "./QuillEditorCustomToolbar.vue?vue&type=script&lang=js&"
export * from "./QuillEditorCustomToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports